import { faUserMd } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Card } from './Basics'

interface Props {
  body: string
  lineClamp?: boolean
  className?: string
}

export const DoctorMessage: React.FC<Props> = ({
  body,
  lineClamp,
  children,
  className,
}) => {
  return (
    <Card className={`pt-6 px-4 bg-sub-color ${className ? className : ''}`}>
      <div className="flex">
        <span className="font-bold text-lg text-app-color">
          <FontAwesomeIcon
            style={{ fontSize: 24, marginRight: 7 }}
            icon={faUserMd}
          />
          医療チーム
        </span>
      </div>
      <p
        className={`mt-2 text-lg whitespace-pre-line ${
          lineClamp ? 'line-clamp-1' : ''
        }`}
      >
        {body}
      </p>
      {children}
    </Card>
  )
}
